import './DrawerCloseButton.scss';

import React from 'react';

import Button from '@/common/components/atoms/Button/Button';
import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';
import { ReactComponent as CloseIcon } from '@/materiaux/assets/icons/close.svg';

const DrawerCloseButton = () => {
  const { handleClose } = useHeaderMenuContext();

  return (
    <Button className="drawer-close-button" onClick={handleClose}>
      <CloseIcon />
    </Button>
  );
};

export default DrawerCloseButton;
